import { render, staticRenderFns } from "./fits-for.vue?vue&type=template&id=4a44af67&"
import script from "./fits-for.vue?vue&type=script&lang=js&"
export * from "./fits-for.vue?vue&type=script&lang=js&"
import style0 from "./fits-for.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports